import { cx } from '@linaria/core';
import { MouseEvent, PointerEvent, ReactNode, useRef } from 'react';
import { getThemeSpacing } from '../styles/appTheme';
import { animateRipple, rippleStyles } from './ripple';
import "./MenuItem.linaria.module.css!=!./MenuItem?./MenuItem.linaria.module.css?css=H4sIAAAAAAAAA3WTzXLbIBSF930RNzMhY5TUduiqu276DAyCKwmJHwWukBym795xYqnG0y6P+M5B9zD3SaDl9cKpnwfV10+lzI13SBphtTmz3S/vMEIIAnePu59gEqCWYve4+xG0MLvHKFwkEYJuvv/+8pEkT9yK1NFDqT5jo34Htn86BbArbzxvsNWmKlUehVLatQT9yE7jsuFQ4HCP1x7R28IxFI7h3mGgwYI3BW/u+aDbrjDYgXeVtf0hjz5q1N6xAEagTrAix2c+xaRfba79cmlBu5bVPigIpPZb0mvkFJdZJ5OVjqMRZ9YY2I47TruD76f3UmVhdOuIRrCRSXAIYXU0ktPzwe7b9k7mfoqomzOR3iE4/LiHRBQBV+8QOf2W3uY5ZJ8gNMbPrNNKgVuJlDh9e5Wyfc9zpxFIHIUE5vwcxLjN1HM0A+xNllOIPrDR69tfTDVvzXlubJ4iBBLBgETmvNvKCxWnfXXqlyqTGepBI0Exkk63nbm8BZHe+MAwCBdHEcBtI9AzPXbzwOmxlQcx/usb6y7D5VrIoQ1+cuqalkT4SoiQl1ckH8zDmlopTru+hmO6k/9LCX6+zgWK/GW2wKPhdEn94mm+tSkdRW1AEYQFH276PD4LNfdrnwoaMZltZtuvfV6LJpDAYSwqNZ7rasaXl1IVS3colu4Wh3v8unSfjj8TGC7yXwQAAA=="
export const MENU_ITEM_PADDING = getThemeSpacing(1, true);

/** the row's type and padding alone — a closed select's display copies them */
export const menuItemStyles = "atm_bx_1owkdjb atm_c8_mavh16 atm_lo_ftgil2 atm_le_ftgil2 atm_lk_ftgil2 atm_ll_ftgil2";
const rowStyles = "atm_mk_h2mmj6 atm_73_usvi9m atm_9s_1txwivl atm_h_1h6ojuz atm_fc_1y6m0gg atm_ks_15vqwwr atm_vv_1q9ccgz atm_9j_tlke0l atm_vb_glywfm atm_r2_1j28jx2 atm_1y17hwk_17gc6ap";
const selectedStyles = "atm_2d_1hjbe7v";
const disabledStyles = "atm_7l_1xvjxo1 atm_9j_73adwj atm_mj_glywfm";
const denseStyles = "atm_lo_i2wt44 atm_le_i2wt44";
export interface MenuItemProps {
  children?: ReactNode;
  className?: string;
  'data-testid'?: string;
  disabled?: boolean;
  dense?: boolean;
  onClick?(event: MouseEvent<HTMLLIElement>): void;
  /** `option` for the rows of a select, so screen readers read a listbox */
  role?: 'menuitem' | 'option';
  selected?: boolean;
  title?: string;
}
const MenuItem = (props: MenuItemProps) => {
  const {
    children,
    className,
    disabled = false,
    dense = false,
    onClick,
    role = 'menuitem',
    selected = false,
    title,
    'data-testid': dataTestId
  } = props;
  const rowRef = useRef<HTMLLIElement>(null);
  const rippleRef = useRef<HTMLSpanElement>(null);
  const onPointerDown = (event: PointerEvent<HTMLLIElement>) => {
    animateRipple(event.clientX, event.clientY, rippleRef, rowRef);
  };
  return <li aria-disabled={disabled || undefined} aria-selected={role === 'option' ? selected : undefined} className={cx('mfc-menu-item', menuItemStyles, rowStyles, selected && selectedStyles, disabled && disabledStyles, dense && denseStyles, className)} data-testid={dataTestId} onClick={onClick} onPointerDown={onPointerDown} ref={rowRef} role={role} title={title}>
            {children}
            <span aria-hidden="true" className={rippleStyles} ref={rippleRef} />
        </li>;
};
export default MenuItem;